export const isMobile = () => matchMedia('(max-width: 768px)').matches;

export const isTablet = () =>
  matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;

export const isDesktop = () => matchMedia('(min-width: 1024px)').matches;

export const nextFrameAsync = () =>
  new Promise(resolve => requestAnimationFrame(() => resolve()));

export const getCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
};

export const setTrackDataLayer = ({ eventName, custom = {} }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...custom
  });
};

export const getQueryParams = () => {
  // eslint-disable-next-line no-undef
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('q');
};
